import { useNavigate, useLocation } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'

export interface FeaturePage {
  name: string
  path: string
  translationKey: string
}

export const FEATURE_PAGES: FeaturePage[] = [
  { name: 'Dispo Prevention', path: '/features/dispo-prevention', translationKey: 'nav.features.dispoPrevent' },
  { name: 'Charts & Analytics', path: '/features/charts-analytics', translationKey: 'nav.features.charts' },
  { name: 'AI Tips', path: '/features/ai-tips', translationKey: 'nav.features.aiTips' },
  { name: 'Roast Mode', path: '/features/roast-mode', translationKey: 'nav.features.roastMode' },
  { name: 'Money Habits Score', path: '/features/habits-score', translationKey: 'nav.features.habitsScore' },
  { name: 'Financial Check-In', path: '/features/check-in', translationKey: 'nav.features.checkIn' },
  { name: 'AzrefyPoints', path: '/features/azrefy-points', translationKey: 'nav.features.points' },
]

export function useFeatureNavigation() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useLanguage()

  const getCurrentIndex = (): number => {
    const index = FEATURE_PAGES.findIndex(page => page.path === location.pathname)
    return index !== -1 ? index : 0
  }

  const currentIndex = getCurrentIndex()
  const totalPages = FEATURE_PAGES.length
  const currentFeature = FEATURE_PAGES[currentIndex]

  const navigateNext = () => {
    if (currentIndex < totalPages - 1) {
      navigate(FEATURE_PAGES[currentIndex + 1].path)
    }
  }

  const navigatePrev = () => {
    if (currentIndex > 0) {
      navigate(FEATURE_PAGES[currentIndex - 1].path)
    }
  }

  const navigateToIndex = (index: number) => {
    if (index >= 0 && index < totalPages) {
      navigate(FEATURE_PAGES[index].path)
    }
  }

  const hasNext = currentIndex < totalPages - 1
  const hasPrev = currentIndex > 0

  const getFeatureName = (index: number): string => {
    const feature = FEATURE_PAGES[index]
    return feature ? t(feature.translationKey) : ''
  }

  return {
    currentIndex,
    totalPages,
    currentFeature,
    navigateNext,
    navigatePrev,
    navigateToIndex,
    hasNext,
    hasPrev,
    getFeatureName,
    features: FEATURE_PAGES,
  }
}
